


import { Component, Vue, Prop } from 'vue-property-decorator';
import { Layer } from '@/components/LayeringEngine/LayeringEngine.models';
import { FloorGraphic, FloorGraphicWithID } from './OverviewGraphic.models';
import LayeringEngine from '@/components/LayeringEngine/index.vue';
import { namespace } from 'vuex-class';
import { Floor } from '@/utils/api';
import { RouteNames } from '@/utils/router/router.models';
import { Location } from 'vue-router';

const summaryModule = namespace('summary');

@Component({
  components: {
    LayeringEngine
  }
})
export default class OverviewGraphic extends Vue {
  @summaryModule.State private routes!: Location[];
  @summaryModule.Getter private attic!: Floor;
  @summaryModule.Getter private groundFloor!: Floor;
  @summaryModule.Getter private upperFloor!: Floor;
  @Prop() private overview!: Layer[];
  @Prop({ default: () => [] }) private floors!: FloorGraphic[];

  /**
   * returns a internationalized route name for the given floor's
   * summary view
   */
  public routeForFloor(floor: FloorGraphicWithID) {
    const candidate = this.routes.find(route => route.name?.slice(3) === this.routeNameForFloor(floor));
    if (candidate) {
      return candidate.name;
    }
    return '';
  }

  /**
   * returns a not-internationalized route name for the given floor's
   * summary view
   */
  private routeNameForFloor(floor: FloorGraphicWithID): string {
    if (this.attic && this.attic.ID === floor.floorID) return RouteNames.SummaryFloorAttic;
    if (this.groundFloor && this.groundFloor.ID === floor.floorID) return RouteNames.SummaryFloorGroundFloor;
    if (this.upperFloor && this.upperFloor.ID === floor.floorID) return RouteNames.SummaryFloorUpperFloor;
    return '';
  }
}
